<template>
    <div class="noCarApply">
        <topNav :title="title"></topNav>
        <section class="list list_cars">
            <div class="logout_box" style="padding:15px 20px;" v-show="!carInfo||(carInfo&&carInfo.result==1)">
                <van-cell-group class="form_box">
                    <van-field class="right_input" v-model="pername" clearable placeholder="请输入车主姓名" />
                </van-cell-group>
                <van-button class="mt" size="large" type='info' @click='addCar'>申请月卡</van-button>
            </div>
            <div class="car_item" v-show="carInfo">
                月卡{{ carInfo?code[carInfo.result]:'' }}
            </div>
            <div class="empty_container" v-show="!carInfo && !loadingCar">
                <div class="cont">
                    <div class="icon icon_noinvoice"></div>
                    <p class="tips">暂无月卡</p>
                </div>
            </div>

            <div class="loadmore" v-if="loadingCar"><van-loading type="spinner" /></div>
        </section>
    </div>
</template>
<script>
import topNav from "../topnav/topnav"
import { DETAIL as API } from "@/assets/api"

export default {
    name: 'noCarApply',
    components: {
        topNav,
    },
    data() {
        return {
            title: "月卡车辆",
            loadingCar: false,
            carInfo: null,
            commid: '',
            parkingno: '',
            pername:'',
            code: {
                '-1': '等待审核',
                '0': '审核通过',
                '1': '审核不通过'
            }
        }
    },
    computed: {

    },
    methods: {
        getCars() {
            this.loadingCar = true
            let req = {
                commid: this.commid,
                parkingno: this.parkingno,
                phonenumber: this.$store.state.phonenumber,
                openid: sessionStorage.getItem("originalId")
            }
            this.$http({
                method: 'post',
                url: API.GET_CAR_LIST,
                data: req,
                success: function (res) {
                    if (res.code == 500) {
                        this.Toast(res.msg)
                        this.loadingCar = false
                        this.carInfo = null
                        return
                    }
                    if (res.data) {
                        this.carInfo = res.data
                    }
                    this.loadingCar = false
                }.bind(this),
                error: function (error) {
                    this.loadingCar = false
                }
            })
        },
        addCar() {
            if(!this.pername){
                this.Toast('请输入车主姓名')
                return
            }
            let req = {
                vehiclemode: 1,
                vehicletype: 2,
                commid: this.commid,
                parkingno: this.parkingno,
                phonenumber: this.$store.state.phonenumber,
                openid: sessionStorage.getItem("originalId"),
                pername:this.pername
            }
            this.$http({
                method: 'post',
                url: API.SET_CAR,
                data: req,
                success: function (res) {
                    if (res.code == 500) {
                        this.Toast(res.msg)
                        return
                    }
                    if (res.code == 0) {
                        let msg = this.code[res.data.result]
                        this.Toast(msg)
                        this.getCars()
                    }
                }.bind(this),
                error: function (error) {
                }
            })
        },
    },
    created() {
        this.commid = this.$route.query.commid
        this.parkingno = this.$route.query.parkingno
        this.getCars()
    },
}
</script>
<style lang="less" scoped>
.noCarApply {
    min-height: 100vh;
    border-bottom: 1px solid #fff;
    box-sizing: border-box;
}
.mt{
    margin-top: 10px;
}
.carname {
    font-size: 17px;
    line-height: 32px;
    text-align: center;
}


.car_item {
    position: relative;
    height: 210px/2;
    width: 705px/2;
    margin: 10px auto;
    background-color: #fff;
    background: url('../../../static/images/bg_carname.png') center no-repeat;
    background-size: 100%;
    font-size: 20px;
    letter-spacing: 2px;
    color: #fff;
    font-family: AlibabaPuHuiTi-Regular;
    line-height: 90px;
}

.emptyTip {
    font-size: 16px;
    text-align: center;
    line-height: 60px;
}

.empty_container {
    margin-top: 80px;

    .cont {
        margin-bottom: 30px;

        .icon_noinvoice {
            width: 161px;
            height: 127px;
            margin: 0 auto;
            background: url('../../../static/images/icon_noinvoice.png') center no-repeat;
            background-size: 100% auto;
        }

        .tips {
            text-align: center;
            color: #333;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/my/noCarApply.vue